// import list from './List';
// export default list;
import list from './cardView';
export default list;
